import { ICompanyData } from "./types/LeadRequisitionType";

export const MOCK_LEAD_REQUISITION_DATA: any = [
  {
    _id: {
      $oid: "66fa69fe571fb8393d55f235",
    },
    webLeadRequestId: "dnca2",
    existingWebLeadScoreDetails: {
      "Referred By": [
        {
          name: "Self-referral",
          score: 0,
          applicable: false,
          factor: 1,
          editable: false,
        },
        {
          name: "Citi Partner-Navan",
          score: 3,
          applicable: true,
          factor: 1,
          editable: false,
        },
        {
          name: "Social Media",
          score: 0,
          applicable: false,
          factor: 1,
          editable: false,
        },
        {
          name: "Partner Website",
          score: 3,
          applicable: true,
          factor: 1,
          editable: false,
        },
        {
          name: "Other Citi Line of Business",
          score: 3,
          applicable: true,
          factor: 1,
          editable: false,
        },
        {
          name: "Another Company",
          score: 3,
          applicable: true,
          factor: 1,
          editable: false,
        },
        {
          name: "Other",
          score: 0,
          applicable: false,
          factor: 1,
          editable: false,
        },
      ],
      Roles: [
        {
          name: "Accountant",
          score: 0,
          applicable: false,
          factor: 1,
          editable: false,
        },
        {
          name: "Assistant",
          score: 0,
          applicable: false,
          factor: 1,
          editable: false,
        },
        {
          name: "Assistant Treasurer",
          score: 1,
          applicable: true,
          factor: 1,
          editable: false,
        },
        {
          name: "Board",
          score: 0,
          applicable: false,
          factor: 1,
          editable: false,
        },
        {
          name: "CEO",
          score: 1,
          applicable: true,
          factor: 1,
          editable: false,
        },
        {
          name: "CFO",
          score: 1,
          applicable: true,
          factor: 1,
          editable: false,
        },
        {
          name: "Chief Sustainability Officer",
          score: 0,
          applicable: false,
          factor: 1,
          editable: false,
        },
        {
          name: "Controller",
          score: 1,
          applicable: true,
          factor: 1,
          editable: false,
        },
        {
          name: "COO",
          score: 1,
          applicable: true,
          factor: 1,
          editable: false,
        },
        {
          name: "CTO",
          score: 1,
          applicable: true,
          factor: 1,
          editable: false,
        },
        {
          name: "Executive Director",
          score: 0,
          applicable: false,
          factor: 1,
          editable: false,
        },
        {
          name: "Finance Manager",
          score: 0,
          applicable: false,
          factor: 1,
          editable: false,
        },
        {
          name: "Finance Manager",
          score: 0,
          applicable: false,
          factor: 1,
          editable: false,
        },
        {
          name: "Financial Advisor",
          score: 0,
          applicable: false,
          factor: 1,
          editable: false,
        },
        {
          name: "Founder",
          score: 1,
          applicable: false,
          factor: 1,
          editable: false,
        },
        {
          name: "General Manager",
          score: 0,
          applicable: false,
          factor: 1,
          editable: false,
        },
        {
          name: "Investment Director",
          score: 0,
          applicable: false,
          factor: 1,
          editable: false,
        },
        {
          name: "Legal Advisor",
          score: 0,
          applicable: false,
          factor: 1,
          editable: false,
        },
        {
          name: "Managing Partner",
          score: 0,
          applicable: false,
          factor: 1,
          editable: false,
        },
        {
          name: "Owner",
          score: 1,
          applicable: true,
          factor: 1,
          editable: false,
        },
        {
          name: "Partner",
          score: 0,
          applicable: false,
          factor: 1,
          editable: false,
        },
        {
          name: "President",
          score: 0,
          applicable: false,
          factor: 1,
          editable: false,
        },
        {
          name: "Treasurer",
          score: 0,
          applicable: false,
          factor: 1,
          editable: false,
        },
        {
          name: "Treasury Operations",
          score: 0,
          applicable: false,
          factor: 1,
          editable: false,
        },
      ],
      "Business Needs": [
        {
          name: "Simplify or consolidate our global banking relationships",
          applicable: false,
          factor: 1,
          editable: false,
          score: 2,
        },
        {
          name: "Expand into new markets domestically or globally",
          applicable: false,
          factor: 1,
          editable: false,
          score: 2,
        },
        {
          name: "Improve working capital and refine supply chain strategies",
          applicable: false,
          factor: 1,
          editable: false,
          score: 2,
        },
        {
          name: "Invest idle cash and manage cash more efficiently",
          applicable: false,
          factor: 1,
          editable: false,
          score: 2,
        },
        {
          name: "Explore credit and equity capital solutions",
          applicable: false,
          factor: 1,
          editable: false,
          score: 2,
        },
        {
          name: "Embed sustainability solutions into our banking",
          applicable: false,
          factor: 1,
          editable: false,
          score: 2,
        },
        {
          name: "Improve or simplify connectivity to our bank(s)",
          applicable: false,
          factor: 1,
          editable: false,
          score: 2,
        },
        {
          name: "I'm looking to achieve something else or I'm not sure yet",
          applicable: false,
          factor: 1,
          editable: false,
          score: 2,
        },
      ],
      Industry: [
        {
          name: "Clean Energy (Alternative/Renewable Power, Grid Management, Equipment, etc.)",
          score: 0,
          applicable: false,
          factor: 1,
          editable: false,
        },
        {
          name: "Consumer Products (Agribusiness, Durables, Food & Beverage, etc.)",
          score: 0,
          applicable: false,
          factor: 1,
          editable: false,
        },
        {
          name: "Consumer Retail (Restaurants, Apparel & Textiles, Specialty Retailer etc.)",
          score: 0,
          applicable: false,
          factor: 1,
          editable: false,
        },
        {
          name: "Digital, Tech & Communications (eCommerce, Software, Tech Hardware etc.)",
          score: 2,
          applicable: false,
          factor: 1,
          editable: false,
        },
        {
          name: "Diversified Services (Consultancies, Law, Workplace Solutions, Engineering & Construction, Travel, etc.)",
          score: 0,
          applicable: false,
          factor: 1,
          editable: false,
        },
        {
          name: "Financial Services (Financial Institutions, Asset Managers, Real Estate, Insurance, etc.)",
          score: 0,
          applicable: false,
          factor: 1,
          editable: false,
        },
        {
          name: "Healthcare/Life Sciences (Pharma, MedTech, Biotech, etc.)",
          score: 2,
          applicable: false,
          factor: 1,
          editable: false,
        },
        {
          name: "Industrials: Emerging Mobility (Aerospace, Industrial Automation, etc.)",
          score: 2,
          applicable: false,
          factor: 1,
          editable: false,
        },
        {
          name: "Industrials: Manufacturing (Capital Goods, Chemicals, Packaging/Paper, Logistics, etc.)",
          score: 0,
          applicable: false,
          factor: 1,
          editable: false,
        },
        {
          name: "Nonprofit (Public & Social Benefit, Higher Edu, Arts & Cultural, Membership Orgs, etc.)",
          score: 0,
          applicable: false,
          factor: 1,
          editable: false,
        },
        {
          name: "Other",
          score: 2,
          applicable: false,
          factor: 1,
          editable: false,
        },
        {
          name: "Consumer (Retail, Products, Agribusiness, etc.)",
          score: 0,
          applicable: false,
          factor: 1,
          editable: false,
        },
        {
          name: "Digital (eCommerce, Software, etc.)",
          score: 2,
          applicable: false,
          factor: 1,
          editable: false,
        },
        {
          name: "Healthcare/Life Sciences",
          score: 2,
          applicable: false,
          factor: 1,
          editable: false,
        },
        {
          name: "Industrials/Manufacturing",
          score: 0,
          applicable: false,
          factor: 1,
          editable: false,
        },
        {
          name: "Not for Profit",
          score: 0,
          applicable: false,
          factor: 1,
          editable: false,
        },
        {
          name: "Services",
          score: 0,
          applicable: false,
          factor: 1,
          editable: false,
        },
        {
          name: "Tech & Communications (Hardware, Media, etc.)",
          score: 0,
          applicable: false,
          factor: 1,
          editable: false,
        },
      ],
      "Sales Size": [
        {
          name: "$10m-$25m",
          score: 0,
          applicable: false,
          factor: 1,
          editable: false,
        },
        {
          name: "$25m-$100m",
          score: 1,
          applicable: false,
          factor: 1,
          editable: false,
        },
        {
          name: "$100m-$1b",
          score: 2,
          applicable: false,
          factor: 1,
          editable: false,
        },
        {
          name: "$1b-$3b",
          score: 0,
          applicable: false,
          factor: 1,
          editable: false,
        },
        {
          name: "Pre-Revenue",
          score: 0,
          applicable: false,
          factor: 1,
          editable: false,
        },
        {
          name: "$10m-$100m",
          score: 0,
          applicable: false,
          factor: 1,
          editable: false,
        },
        {
          name: "$1b-$30b",
          score: 0,
          applicable: false,
          factor: 1,
          editable: false,
        },
        {
          name: "$10m-$1000m",
          score: 0,
          applicable: false,
          factor: 1,
          editable: false,
        },
      ],
      Jurisdictions: [
        {
          name: "Afghanistan",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Aland Islands",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Albania",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Algeria",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Andorra",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Angola",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Anguilla",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Antarctica",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Antigua and Barbuda",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Argentina",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Armenia",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Aruba",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Australia",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Austria",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Azerbaijan",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Bahamas",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Bahrain",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Bangladesh",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Barbados",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Belarus",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Belgium",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Belize",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Benin",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Bermuda",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Bhutan",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Bolivia, Plurinational State of",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Bonaire, Sint Eustatius and Saba",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Bosnia and Herzegovina",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Botswana",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Bouvet Island",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Brazil",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "British Indian Ocean Territory",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Brunei Darussalam",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Bulgaria",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Burkina Faso",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Burundi",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Cambodia",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Cameroon",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Canada",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Cape Verde",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Cayman Islands",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Central African Republic",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Chad",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Chile",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "China",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Christmas Island",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Cocos (Keeling) Islands",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Colombia",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Comoros",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Congo",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Congo, the Democratic Republic of the",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Cook Islands",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Costa Rica",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Cote d’Ivoire",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Croatia",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Cuba",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Curaçao",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Cyprus",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Czech Republic",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Denmark",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Djibouti",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Dominica",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Dominican Republic",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Ecuador",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Egypt",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "El Salvador",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Equatorial Guinea",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Eritrea",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Estonia",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Ethiopia",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Falkland Islands (Malvinas)",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Faroe Islands",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Fiji",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Finland",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "France",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "French Guiana",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "French Polynesia",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "French Southern Territories",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Gabon",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Gambia",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Georgia",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Germany",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Ghana",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Gibraltar",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Greece",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Greenland",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Grenada",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Guadeloupe",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Guatemala",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Guernsey",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Guinea",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Guinea-Bissau",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Guyana",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Haiti",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Heard Island and McDonald Islands",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Holy See (Vatican City State)",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Honduras",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Hong Kong SAR",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Hungary",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Iceland",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "India",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Indonesia",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Iran, Islamic Republic of",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Iraq",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Ireland",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Isle of Man",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Israel",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Italy",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Jamaica",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Japan",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Jersey",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Jordan",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Kazakhstan",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Kenya",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Kiribati",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Korea, Democratic People’s Republic of",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Korea, Republic of",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Kuwait",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Kyrgyzstan",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Lao People’s Democratic Republic",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Latvia",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Lebanon",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Lesotho",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Liberia",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Libya",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Liechtenstein",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Lithuania",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Luxembourg",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Macao",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Macedonia, the former Yugoslav Republic of",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Madagascar",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Malawi",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Malaysia",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Maldives",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Mali",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Malta",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Martinique",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Mauritania",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Mauritius",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Mayotte",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Mexico",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Moldova, Republic of",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Monaco",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Mongolia",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Montenegro",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Montserrat",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Morocco",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Mozambique",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Myanmar",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Namibia",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Nauru",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Nepal",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Netherlands",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "New Caledonia",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "New Zealand",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Nicaragua",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Niger",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Nigeria",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Niue",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Norfolk Island",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Norway",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Oman",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Pakistan",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Palestine",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Panama",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Papua New Guinea",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Paraguay",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Peru",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Philippines",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Pitcairn",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Poland",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Portugal",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Qatar",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Reunion",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Romania",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Russian Federation",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Rwanda",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Saint Barthélemy",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Saint Helena, Ascension and Tristan da Cunha",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Saint Kitts and Nevis",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Saint Lucia",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Saint Martin (French part)",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Saint Pierre and Miquelon",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Saint Vincent and the Grenadines",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Samoa",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "San Marino",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Sao Tome and Principe",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Saudi Arabia",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Senegal",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Serbia",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Seychelles",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Sierra Leone",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Singapore",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Sint Maarten (Dutch part)",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Slovakia",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Slovenia",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Solomon Islands",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Somalia",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "South Africa",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "South Georgia and the South Sandwich Islands",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "South Sudan",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Spain",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Sri Lanka",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Sudan",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Suriname",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Svalbard and Jan Mayen",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Swaziland",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Sweden",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Switzerland",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Syrian Arab Republic",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Taiwan",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Tajikistan",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Tanzania, United Republic of",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Thailand",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Timor-Leste",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Togo",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Tokelau",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Tonga",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Trinidad and Tobago",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Tunisia",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Turkey",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Turkmenistan",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Turks and Caicos Islands",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Tuvalu",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Uganda",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Ukraine",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "United Arab Emirates",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "United Kingdom",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "United States",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Uruguay",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Uzbekistan",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Vanuatu",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Venezuela, Bolivarian Republic of",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Vietnam",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Virgin Islands, British",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Wallis and Futuna",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Western Sahara",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Yemen",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Zambia",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Zimbabwe",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
      ],
      "Is Company VC or PE Backed": [
        {
          name: "Yes",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "No",
          score: -1,
          factor: 1,
          editable: false,
          applicable: false,
        },
      ],
      Email: [
        {
          name: "Corporate",
          score: 1,
          factor: 1,
          editable: false,
          applicable: false,
        },
        {
          name: "Personal",
          score: -1,
          factor: 1,
          editable: false,
          applicable: false,
        },
      ],
    },
    _class: "com.citi.dnca.be.weblead.model.WebLead",
  },
];

export const MOCK_LEAD_SCORE_LIST: any = [
  {
    webLeadRequestId: "12345",
    companyInfo: {
      businessInfo: {
        category: "Reffered By",
        criteria: "Citi Partner-Navan",
        score: 0,
        editEnable: false,
      },
      operatedCountry: {
        category: "Jurisdiction",
        criteria: "Afghanistan,Aland Islands,Albania",
        score: 3,
        editEnable: false,
      },
      industry: {
        category: "Industry",
        criteria: "Consumer (Retail, Products, Agribusiness, etc.)",
        score: 2,
        editEnable: false,
      },
      salesSize: {
        category: "Sales Size",
        criteria: "$10m-$100m",
        score: 1,
        editEnable: false,
      },
      isCompanyVCorPEBacked: {
        category: "Is Company VC or PE Backed",
        criteria: "Yes",
        score: 1,
        editEnable: false,
      },
      website: {
        category: "Website",
        criteria: "Correct website",
        score: 1,
        editEnable: false,
      },
    },
    contactInfo: {
      role: {
        category: "Role",
        criteria: "Accountant",
        score: 1,
        editEnable: false,
      },
      email: {
        category: "Email",
        criteria: "Corporate/Private",
        score: 1,
        editEnable: false,
      },
    },
    businessNeeds: [
      {
        category: "Business Needs",
        criteria: "Simplify or our global banking relationships",
        score: 1,
        editEnable: false,
      },
      {
        category: "Business Needs",
        criteria: "Simplify or consolidate our global banking relationships",
        score: 1,
        editEnable: false,
      },
    ],
    totalScore: 15,
  },
  {
    webLeadRequestId: "123455",
    companyInfo: {
      businessInfo: {
        category: "Reffered By",
        criteria: "Citi Partner-Navan",
        score: 0,
        editEnable: false,
      },
      operatedCountry: {
        category: "Jurisdiction",
        criteria: "Afghanistan,Aland Islands,Albania",
        score: 3,
        editEnable: false,
      },
      industry: {
        category: "Industry",
        criteria: "Consumer (Retail, Products, Agribusiness, etc.)",
        score: 2,
        editEnable: false,
      },
      salesSize: {
        category: "Sales Size",
        criteria: "$10m-$100m",
        score: 1,
        editEnable: false,
      },
      isCompanyVCorPEBacked: {
        category: "Is Company VC or PE Backed",
        criteria: "Yes",
        score: 1,
        editEnable: false,
      },
      website: {
        category: "Website",
        criteria: "Correct website",
        score: 1,
        editEnable: false,
      },
    },
    contactInfo: {
      role: {
        category: "Role",
        criteria: "Accountant",
        score: 1,
        editEnable: false,
      },
      email: {
        category: "Email",
        criteria: "Corporate/Private",
        score: 1,
        editEnable: false,
      },
    },
    businessNeeds: [
      {
        category: "Business Needs",
        criteria: "Simplify or consolidate our global banking relationships",
        score: 1,
        editEnable: false,
      },
      {
        category: "Business Needs",
        criteria: "Simplify or relationships",
        score: 1,
        editEnable: false,
      },
    ],
    totalScore: 12,
  },
];

export const MOCK_COMPANY_DATA: ICompanyData[] = [
  {
    business_name: "Microsoft Private Limited",
    street_address: "49 Yonge Street",
    city_name: "Florida",
    address: "49 Yonge Street Palm Tree Heaven, Florida, USA",
    global_ultimate_country_name: "USA",
    sic_naics__c: "3841",
    industry_sector: "Technology",
    duns: "442106902",
    country_name: [
      "CANADA",
      "SWITZERLAND",
      "AUSTRIA",
      "GERMANY",
      "NETHERLANDS",
      "CHINA",
      "ENGLAND",
      "USA",
      "AUSTRALIA",
      "HONG KONG",
      "IRELAND",
    ],
    industry: "Technology",
    state_or_province_abbreviation: "ON",
    secp_city: null,
  },
  {
    business_name: "Microsoft Corporation",
    street_address: "49 Yonge Street",
    city_name: "Florida",
    address: "49 Yonge Street Palm Tree Heaven, NY, USA",
    global_ultimate_country_name: "USA",
    sic_naics__c: "3841",
    industry_sector: "Technology",
    duns: "442106903",
    country_name: [
      "CANADA",
      "SWITZERLAND",
      "AUSTRIA",
      "GERMANY",
      "NETHERLANDS",
      "CHINA",
      "ENGLAND",
      "USA",
      "AUSTRALIA",
      "HONG KONG",
      "IRELAND",
    ],
    industry: "Technology",
    state_or_province_abbreviation: "ON",
    secp_city: null,
  },
  {
    business_name: "Micro Interactive Pvt. Ltd",
    street_address: "6415 Northwest Dr Unit 11",
    city_name: "MISSISSAUGA",
    address: "ON MISSISSAUGA 6415 Northwest Dr Unit 11 L4V 1X1",
    global_ultimate_country_name: "USA",
    sic_naics__c: "3841",
    industry_sector: "Pharmaceuticals and Medical Devices",
    duns: "442106904",
    country_name: [
      "CANADA",
      "SWITZERLAND",
      "AUSTRIA",
      "GERMANY",
      "NETHERLANDS",
      "CHINA",
      "ENGLAND",
      "USA",
      "AUSTRALIA",
      "HONG KONG",
      "IRELAND",
    ],
    industry: "Healthcare",
    state_or_province_abbreviation: "ON",
    secp_city: null,
  },
];

export const contactUsOptions = {
  companyStatuses: [
    "Expanding internationally for the first time",
    "Growing our existing international presence and/or looking to expand into multiple new markets at one time",
    "Already large globally and need to simplify our banking",
    "Growing rapidly in our domestic market",
    "About to grow rapidly domestically and need to avoid inefficiency",
    "Already large domestically and need to simplify our banking",
  ],
  challenges: [
    "Collecting and/or reconciling money",
    "Making payments cheaply and efficiently",
    "Gaining visibility into global cash position",
    "Choosing the right funding for our operations / closing working capital gaps",
    "Managing our supply chain and trade flows",
    "Connecting seamlessly with our bank(s)",
  ],
  referralSource: [
    "Citi Partner",
    "Social Media",
    "Partner Website",
    "Other Citi Line of Business",
    "Another Company",
    "Citi Global Reputation",
    "Search Engine",
    "Other",
  ],
  citiPartner: ["NAVAN"],
  roles: [
    "Accountant",
    "Assistant",
    "Assistant Treasurer",
    "Board",
    "CEO",
    "CFO",
    "Chief Sustainability Officer",
    "Controller",
    "COO",
    "CTO",
    "Executive Director",
    "Finance Manager",
    "Financial Advisor",
    "Founder",
    "General Manager",
    "Investment Director",
    "Legal Advisor",
    "Managing Partner",
    "Owner",
    "Partner",
    "President",
    "Treasurer",
    "Treasury Operations",
    "Other",
  ],
  businessNeeds: [
    {
      title: "Simplify or consolidate our global banking relationships",
      type: "globe",
    },
    {
      title: "Expand into new markets domestically or globally",
      type: "latam",
    },
    {
      title: "Improve working capital and refine supply chain strategies",
      type: "dollarRefresh",
    },
    {
      title: "Invest idle cash and manage cash more efficiently",
      type: "barChartDollar",
    },
    {
      title: "Explore credit and equity capital solutions",
      type: "dollarBillStack",
    },
    {
      title: "Embed sustainability solutions into our banking",
      type: "green",
    },
    {
      title: "Improve or simplify connectivity to our bank(s)",
      type: "flshOn",
    },
    {
      title: "I'm looking to achieve something else or I'm not sure yet",
      type: "help",
    },
  ],
  countries: {
    Argentina: {
      industry: {
        "Consumer (Retail, Products, Agribusiness, etc)": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Digital (eCommerce, Software, etc)": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Healthcare/Life Sciences": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Industrials/Manufacturing": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Not for Profit": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        Services: ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Tech & Communications (Hardware, Media, etc)": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        Other: ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
      },
      userContactMailTo: "",
    },
    Australia: {
      industry: {
        "Consumer (Retail, Products, Agribusiness, etc)": [
          "$10m-$25m",
          "$25m-$100m",
          "$100m-$1b",
          "$1b-$3b",
        ],
        "Digital (eCommerce, Software, etc)": ["$10m-$25m", "$25m-$100m", "$100m-$1b", "$1b-$3b"],
        "Healthcare/Life Sciences": ["$10m-$25m", "$25m-$100m", "$100m-$1b", "$1b-$3b"],
        "Industrials/Manufacturing": ["$10m-$25m", "$25m-$100m", "$100m-$1b", "$1b-$3b"],
        "Not for Profit": ["$10m-$25m", "$25m-$100m", "$100m-$1b", "$1b-$3b"],
        Services: ["$10m-$25m", "$25m-$100m", "$100m-$1b", "$1b-$3b"],
        "Tech & Communications (Hardware, Media, etc)": [
          "$10m-$25m",
          "$25m-$100m",
          "$100m-$1b",
          "$1b-$3b",
        ],
        Other: ["$10m-$25m", "$25m-$100m", "$100m-$1b", "$1b-$3b"],
      },
      userContactMailTo: "",
    },
    Austria: {
      industry: {
        "Digital (eCommerce, Software, etc)": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
      },
      userContactMailTo: "",
    },
    Bahrain: {
      industry: {
        "Consumer (Retail, Products, Agribusiness, etc)": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Digital (eCommerce, Software, etc)": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Healthcare/Life Sciences": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Industrials/Manufacturing": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Not for Profit": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        Services: ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Tech & Communications (Hardware, Media, etc)": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        Other: ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
      },
      userContactMailTo: "",
    },
    Belgium: {
      industry: {
        "Consumer (Retail, Products, Agribusiness, etc)": ["$100m-$1b", "$1b-$3b"],
        "Digital (eCommerce, Software, etc)": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Healthcare/Life Sciences": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Industrials/Manufacturing": ["$100m-$1b", "$1b-$3b"],
        "Not for Profit": ["$100m-$1b", "$1b-$3b"],
        Services: ["$100m-$1b", "$1b-$3b"],
        "Tech & Communications (Hardware, Media, etc)": ["$100m-$1b", "$1b-$3b"],
        Other: ["$100m-$1b", "$1b-$3b"],
      },
      userContactMailTo: "",
    },
    Brazil: {
      industry: {
        "Consumer (Retail, Products, Agribusiness, etc)": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Digital (eCommerce, Software, etc)": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Healthcare/Life Sciences": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Industrials/Manufacturing": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Not for Profit": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        Services: ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Tech & Communications (Hardware, Media, etc)": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        Other: ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
      },
      userContactMailTo: "",
    },
    Canada: {
      industry: {
        "Consumer (Retail, Products, Agribusiness, etc)": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Digital (eCommerce, Software, etc)": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Healthcare/Life Sciences": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Industrials/Manufacturing": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Not for Profit": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        Services: ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Tech & Communications (Hardware, Media, etc)": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        Other: ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
      },
      userContactMailTo: "",
    },
    China: {
      industry: {
        "Consumer (Retail, Products, Agribusiness, etc)": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Digital (eCommerce, Software, etc)": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Healthcare/Life Sciences": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Industrials/Manufacturing": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Not for Profit": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        Services: ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Tech & Communications (Hardware, Media, etc)": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        Other: ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
      },
      userContactMailTo: "",
    },
    "Czech Republic": {
      industry: {
        "Consumer (Retail, Products, Agribusiness, etc)": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Digital (eCommerce, Software, etc)": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Healthcare/Life Sciences": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Industrials/Manufacturing": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Not for Profit": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        Services: ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Tech & Communications (Hardware, Media, etc)": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        Other: ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
      },
      userContactMailTo: "",
    },
    Denmark: {
      industry: {
        "Consumer (Retail, Products, Agribusiness, etc)": ["$100m-$1b", "$1b-$3b"],
        "Digital (eCommerce, Software, etc)": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Healthcare/Life Sciences": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Industrials/Manufacturing": ["$100m-$1b", "$1b-$3b"],
        "Not for Profit": ["$100m-$1b", "$1b-$3b"],
        Services: ["$100m-$1b", "$1b-$3b"],
        "Tech & Communications (Hardware, Media, etc)": ["$100m-$1b", "$1b-$3b"],
        Other: ["$100m-$1b", "$1b-$3b"],
      },
      userContactMailTo: "",
    },
    Finland: {
      industry: {
        "Consumer (Retail, Products, Agribusiness, etc)": ["$100m-$1b", "$1b-$3b"],
        "Digital (eCommerce, Software, etc)": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Healthcare/Life Sciences": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Industrials/Manufacturing": ["$100m-$1b", "$1b-$3b"],
        "Not for Profit": ["$100m-$1b", "$1b-$3b"],
        Services: ["$100m-$1b", "$1b-$3b"],
        "Tech & Communications (Hardware, Media, etc)": ["$100m-$1b", "$1b-$3b"],
        Other: ["$100m-$1b", "$1b-$3b"],
      },
      userContactMailTo: "",
    },
    France: {
      industry: {
        "Digital (eCommerce, Software, etc)": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Consumer (Retail, Products, Agribusiness, etc)": ["$100m-$1b", "$1b-$3b"],
        "Healthcare/Life Sciences": ["$100m-$1b", "$1b-$3b"],
        "Industrials/Manufacturing": ["$100m-$1b", "$1b-$3b"],
        "Not for Profit": ["$100m-$1b", "$1b-$3b"],
        Services: ["$100m-$1b", "$1b-$3b"],
        "Tech & Communications (Hardware, Media, etc)": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        Other: ["$100m-$1b", "$1b-$3b"],
      },
      userContactMailTo: "",
    },
    Germany: {
      industry: {
        "Consumer (Retail, Products, Agribusiness, etc)": ["$100m-$1b", "$1b-$3b"],
        "Digital (eCommerce, Software, etc)": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Healthcare/Life Sciences": ["$100m-$1b", "$1b-$3b"],
        "Industrials/Manufacturing": ["$100m-$1b", "$1b-$3b"],
        "Not for Profit": ["$100m-$1b", "$1b-$3b"],
        Services: ["$100m-$1b", "$1b-$3b"],
        "Tech & Communications (Hardware, Media, etc)": ["$100m-$1b", "$1b-$3b"],
        Other: ["$100m-$1b", "$1b-$3b"],
      },
      userContactMailTo: "",
    },
    "Hong Kong SAR": {
      industry: {
        "Consumer (Retail, Products, Agribusiness, etc)": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Digital (eCommerce, Software, etc)": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Healthcare/Life Sciences": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Industrials/Manufacturing": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Not for Profit": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        Services: ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Tech & Communications (Hardware, Media, etc)": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        Other: ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
      },
      userContactMailTo: "",
    },
    Hungary: {
      industry: {
        "Consumer (Retail, Products, Agribusiness, etc)": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Digital (eCommerce, Software, etc)": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Healthcare/Life Sciences": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Industrials/Manufacturing": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Not for Profit": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        Services: ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Tech & Communications (Hardware, Media, etc)": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        Other: ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
      },
      userContactMailTo: "",
    },
    India: {
      industry: {
        "Consumer (Retail, Products, Agribusiness, etc)": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Digital (eCommerce, Software, etc)": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Healthcare/Life Sciences": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Industrials/Manufacturing": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Not for Profit": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        Services: ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Tech & Communications (Hardware, Media, etc)": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        Other: ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
      },
      userContactMailTo: "",
    },
    Indonesia: {
      industry: {
        "Consumer (Retail, Products, Agribusiness, etc)": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Digital (eCommerce, Software, etc)": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Healthcare/Life Sciences": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Industrials/Manufacturing": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Not for Profit": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        Services: ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Tech & Communications (Hardware, Media, etc)": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        Other: ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
      },
      userContactMailTo: "",
    },
    Ireland: {
      industry: {
        "Digital (eCommerce, Software, etc)": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Consumer (Retail, Products, Agribusiness, etc)": ["$100m-$1b", "$1b-$3b"],
        "Healthcare/Life Sciences": ["$100m-$1b", "$1b-$3b"],
        "Industrials/Manufacturing": ["$100m-$1b", "$1b-$3b"],
        "Not for Profit": ["$100m-$1b", "$1b-$3b"],
        Services: ["$100m-$1b", "$1b-$3b"],
        "Tech & Communications (Hardware, Media, etc)": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        Other: ["$100m-$1b", "$1b-$3b"],
      },
      userContactMailTo: "",
    },
    Israel: {
      industry: {
        "Digital (eCommerce, Software, etc)": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
      },
      userContactMailTo: "",
    },
    Italy: {
      industry: {
        "Consumer (Retail, Products, Agribusiness, etc)": ["$100m-$1b", "$1b-$3b"],
        "Digital (eCommerce, Software, etc)": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Healthcare/Life Sciences": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Industrials/Manufacturing": ["$100m-$1b", "$1b-$3b"],
        "Not for Profit": ["$100m-$1b", "$1b-$3b"],
        Services: ["$100m-$1b", "$1b-$3b"],
        "Tech & Communications (Hardware, Media, etc)": ["$100m-$1b", "$1b-$3b"],
        Other: ["$100m-$1b", "$1b-$3b"],
      },
      userContactMailTo: "",
    },
    Japan: {
      industry: {
        "Consumer (Retail, Products, Agribusiness, etc)": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Digital (eCommerce, Software, etc)": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Healthcare/Life Sciences": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Industrials/Manufacturing": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Not for Profit": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        Services: ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Tech & Communications (Hardware, Media, etc)": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        Other: ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
      },
      userContactMailTo: "",
    },
    Jordan: {
      industry: {
        "Consumer (Retail, Products, Agribusiness, etc)": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Digital (eCommerce, Software, etc)": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Healthcare/Life Sciences": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Industrials/Manufacturing": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Not for Profit": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        Services: ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Tech & Communications (Hardware, Media, etc)": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        Other: ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
      },
      userContactMailTo: "",
    },
    "Korea, Republic of": {
      industry: {
        "Consumer (Retail, Products, Agribusiness, etc)": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Digital (eCommerce, Software, etc)": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Healthcare/Life Sciences": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Industrials/Manufacturing": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Not for Profit": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        Services: ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Tech & Communications (Hardware, Media, etc)": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        Other: ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
      },
      userContactMailTo: "",
    },
    Luxembourg: {
      industry: {
        "Consumer (Retail, Products, Agribusiness, etc)": ["$100m-$1b", "$1b-$3b"],
        "Digital (eCommerce, Software, etc)": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Healthcare/Life Sciences": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Industrials/Manufacturing": ["$100m-$1b", "$1b-$3b"],
        "Not for Profit": ["$100m-$1b", "$1b-$3b"],
        Services: ["$100m-$1b", "$1b-$3b"],
        "Tech & Communications (Hardware, Media, etc)": ["$100m-$1b", "$1b-$3b"],
        Other: ["$100m-$1b", "$1b-$3b"],
      },
      userContactMailTo: "",
    },
    Malaysia: {
      industry: {
        "Consumer (Retail, Products, Agribusiness, etc)": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Digital (eCommerce, Software, etc)": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Healthcare/Life Sciences": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Industrials/Manufacturing": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Not for Profit": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        Services: ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Tech & Communications (Hardware, Media, etc)": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        Other: ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
      },
      userContactMailTo: "",
    },
    Mexico: {
      industry: {
        "Consumer (Retail, Products, Agribusiness, etc)": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Digital (eCommerce, Software, etc)": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Healthcare/Life Sciences": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Industrials/Manufacturing": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Not for Profit": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        Services: ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Tech & Communications (Hardware, Media, etc)": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        Other: ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
      },
      userContactMailTo: "",
    },
    Netherlands: {
      industry: {
        "Consumer (Retail, Products, Agribusiness, etc)": ["$100m-$1b", "$1b-$3b"],
        "Digital (eCommerce, Software, etc)": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Healthcare/Life Sciences": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Industrials/Manufacturing": ["$100m-$1b", "$1b-$3b"],
        "Not for Profit": ["$100m-$1b", "$1b-$3b"],
        Services: ["$100m-$1b", "$1b-$3b"],
        "Tech & Communications (Hardware, Media, etc)": ["$100m-$1b", "$1b-$3b"],
        Other: ["$100m-$1b", "$1b-$3b"],
      },
      userContactMailTo: "",
    },
    Norway: {
      industry: {
        "Consumer (Retail, Products, Agribusiness, etc)": ["$100m-$1b", "$1b-$3b"],
        "Digital (eCommerce, Software, etc)": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Healthcare/Life Sciences": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Industrials/Manufacturing": ["$100m-$1b", "$1b-$3b"],
        "Not for Profit": ["$100m-$1b", "$1b-$3b"],
        Services: ["$100m-$1b", "$1b-$3b"],
        "Tech & Communications (Hardware, Media, etc)": ["$100m-$1b", "$1b-$3b"],
        Other: ["$100m-$1b", "$1b-$3b"],
      },
      userContactMailTo: "",
    },
    Poland: {
      industry: {
        "Consumer (Retail, Products, Agribusiness, etc)": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Digital (eCommerce, Software, etc)": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Healthcare/Life Sciences": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Industrials/Manufacturing": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Not for Profit": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        Services: ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Tech & Communications (Hardware, Media, etc)": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        Other: ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
      },
      userContactMailTo: "",
    },
    Portugal: {
      industry: {
        "Consumer (Retail, Products, Agribusiness, etc)": ["$100m-$1b", "$1b-$3b"],
        "Digital (eCommerce, Software, etc)": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Healthcare/Life Sciences": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Industrials/Manufacturing": ["$100m-$1b", "$1b-$3b"],
        "Not for Profit": ["$100m-$1b", "$1b-$3b"],
        Services: ["$100m-$1b", "$1b-$3b"],
        "Tech & Communications (Hardware, Media, etc)": ["$100m-$1b", "$1b-$3b"],
        Other: ["$100m-$1b", "$1b-$3b"],
      },
      userContactMailTo: "",
    },
    Romania: {
      industry: {
        "Consumer (Retail, Products, Agribusiness, etc)": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Digital (eCommerce, Software, etc)": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Healthcare/Life Sciences": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Industrials/Manufacturing": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Not for Profit": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        Services: ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Tech & Communications (Hardware, Media, etc)": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        Other: ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
      },
      userContactMailTo: "",
    },
    Singapore: {
      industry: {
        "Consumer (Retail, Products, Agribusiness, etc)": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Digital (eCommerce, Software, etc)": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Healthcare/Life Sciences": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Industrials/Manufacturing": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Not for Profit": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        Services: ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Tech & Communications (Hardware, Media, etc)": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        Other: ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
      },
      userContactMailTo: "",
    },
    Slovakia: {
      industry: {
        "Consumer (Retail, Products, Agribusiness, etc)": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Digital (eCommerce, Software, etc)": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Healthcare/Life Sciences": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Industrials/Manufacturing": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Not for Profit": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        Services: ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Tech & Communications (Hardware, Media, etc)": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        Other: ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
      },
      userContactMailTo: "",
    },
    Spain: {
      industry: {
        "Consumer (Retail, Products, Agribusiness, etc)": ["$100m-$1b", "$1b-$3b"],
        "Digital (eCommerce, Software, etc)": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Healthcare/Life Sciences": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Industrials/Manufacturing": ["$100m-$1b", "$1b-$3b"],
        "Not for Profit": ["$100m-$1b", "$1b-$3b"],
        Services: ["$100m-$1b", "$1b-$3b"],
        "Tech & Communications (Hardware, Media, etc)": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        Other: ["$100m-$1b", "$1b-$3b"],
      },
      userContactMailTo: "",
    },
    Sweden: {
      industry: {
        "Consumer (Retail, Products, Agribusiness, etc)": ["$100m-$1b", "$1b-$3b"],
        "Digital (eCommerce, Software, etc)": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Healthcare/Life Sciences": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Industrials/Manufacturing": ["$100m-$1b", "$1b-$3b"],
        "Not for Profit": ["$100m-$1b", "$1b-$3b"],
        Services: ["$100m-$1b", "$1b-$3b"],
        "Tech & Communications (Hardware, Media, etc)": ["$100m-$1b", "$1b-$3b"],
        Other: ["$100m-$1b", "$1b-$3b"],
      },
      userContactMailTo: "",
    },
    Switzerland: {
      industry: {
        "Consumer (Retail, Products, Agribusiness, etc)": ["$100m-$1b", "$1b-$3b"],
        "Digital (eCommerce, Software, etc)": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Healthcare/Life Sciences": ["$100m-$1b", "$1b-$3b"],
        "Industrials/Manufacturing": ["$100m-$1b", "$1b-$3b"],
        "Not for Profit": ["$100m-$1b", "$1b-$3b"],
        Services: ["$100m-$1b", "$1b-$3b"],
        "Tech & Communications (Hardware, Media, etc)": ["$100m-$1b", "$1b-$3b"],
        Other: ["$100m-$1b", "$1b-$3b"],
      },
      userContactMailTo: "",
    },
    Taiwan: {
      industry: {
        "Consumer (Retail, Products, Agribusiness, etc)": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Digital (eCommerce, Software, etc)": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Healthcare/Life Sciences": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Industrials/Manufacturing": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Not for Profit": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        Services: ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Tech & Communications (Hardware, Media, etc)": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        Other: ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
      },
      userContactMailTo: "",
    },
    Thailand: {
      industry: {
        "Consumer (Retail, Products, Agribusiness, etc)": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Digital (eCommerce, Software, etc)": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Healthcare/Life Sciences": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Industrials/Manufacturing": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Not for Profit": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        Services: ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Tech & Communications (Hardware, Media, etc)": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        Other: ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
      },
      userContactMailTo: "",
    },
    Turkey: {
      industry: {
        "Consumer (Retail, Products, Agribusiness, etc)": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Digital (eCommerce, Software, etc)": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Healthcare/Life Sciences": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Industrials/Manufacturing": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Not for Profit": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        Services: ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Tech & Communications (Hardware, Media, etc)": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        Other: ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
      },
      userContactMailTo: "",
    },
    Ukraine: {
      industry: {
        "Consumer (Retail, Products, Agribusiness, etc)": ["$100m-$1b", "$1b-$3b"],
        "Digital (eCommerce, Software, etc)": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Healthcare/Life Sciences": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Industrials/Manufacturing": ["$100m-$1b", "$1b-$3b"],
        "Not for Profit": ["$100m-$1b", "$1b-$3b"],
        Services: ["$100m-$1b", "$1b-$3b"],
        "Tech & Communications (Hardware, Media, etc)": ["$100m-$1b", "$1b-$3b"],
        Other: ["$100m-$1b", "$1b-$3b"],
      },
      userContactMailTo: "",
    },
    "United Arab Emirates": {
      industry: {
        "Consumer (Retail, Products, Agribusiness, etc)": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Digital (eCommerce, Software, etc)": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Healthcare/Life Sciences": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Industrials/Manufacturing": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Not for Profit": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        Services: ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Tech & Communications (Hardware, Media, etc)": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        Other: ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
      },
      userContactMailTo: "",
    },
    "United Kingdom": {
      industry: {
        "Consumer (Retail, Products, Agribusiness, etc)": ["$100m-$1b", "$1b-$3b"],
        "Digital (eCommerce, Software, etc)": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Healthcare/Life Sciences": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Industrials/Manufacturing": ["$100m-$1b", "$1b-$3b"],
        "Not for Profit": ["$100m-$1b", "$1b-$3b"],
        Services: ["$100m-$1b", "$1b-$3b"],
        "Tech & Communications (Hardware, Media, etc)": ["$100m-$1b", "$1b-$3b"],
        Other: ["$100m-$1b", "$1b-$3b"],
      },
      userContactMailTo: "",
    },
    "United States": {
      industry: {
        "Clean Energy (Alternative/Renewable Power, Grid Management, Equipment, etc)": [
          "$10m-$25m",
          "$25m-$100m",
          "$100m-$1b",
          "$1b-$3b",
        ],
        "Consumer Products (Agribusiness, Durables, Food & Beverage, etc)": [
          "$10m-$25m",
          "$25m-$100m",
          "$100m-$1b",
          "$1b-$3b",
        ],
        "Consumer Retail (Restaurants, Apparel & Textiles, Specialty Retailer etc)": [
          "$10m-$25m",
          "$25m-$100m",
          "$100m-$1b",
          "$1b-$3b",
        ],
        "Digital, Tech & Communications (eCommerce, Software, Tech Hardware etc)": [
          "Pre-Revenue",
          "$10m-$25m",
          "$25m-$100m",
          "$100m-$1b",
          "$1b-$3b",
        ],
        "Diversified Services (Consultancies, Law, Workplace Solutions, Engineering & Construction, Travel, etc)":
          ["$10m-$25m", "$25m-$100m", "$100m-$1b", "$1b-$3b"],
        "Financial Services (Financial Institutions, Asset Managers, Real Estate, Insurance, etc)":
          ["$10m-$25m", "$25m-$100m", "$100m-$1b", "$1b-$3b"],
        "Healthcare/Life Sciences (Pharma, MedTech, Biotech, etc)": [
          "Pre-Revenue",
          "$10m-$25m",
          "$25m-$100m",
          "$100m-$1b",
          "$1b-$3b",
        ],
        "Industrials: Emerging Mobility (Aerospace, Industrial Automation, etc)": [
          "Pre-Revenue",
          "$10m-$25m",
          "$25m-$100m",
          "$100m-$1b",
          "$1b-$3b",
        ],
        "Industrials: Manufacturing (Capital Goods, Chemicals, Packaging/Paper, Logistics, etc)": [
          "$10m-$25m",
          "$25m-$100m",
          "$100m-$1b",
          "$1b-$3b",
        ],
        "Nonprofit (Public & Social Benefit, Higher Edu, Arts & Cultural, Membership Orgs, etc)": [
          "$10m-$25m",
          "$25m-$100m",
          "$100m-$1b",
          "$1b-$3b",
        ],
        Other: ["$10m-$25m", "$25m-$100m", "$100m-$1b", "$1b-$3b"],
      },
      userContactMailTo: "",
    },
    Vietnam: {
      industry: {
        "Consumer (Retail, Products, Agribusiness, etc)": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Digital (eCommerce, Software, etc)": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Healthcare/Life Sciences": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Industrials/Manufacturing": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Not for Profit": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        Services: ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        "Tech & Communications (Hardware, Media, etc)": ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
        Other: ["$10m-$100m", "$100m-$1b", "$1b-$3b"],
      },
      userContactMailTo: "",
    },
  },
  personalEmailDomains: ["gmail", "yahoo", "hotmail"],
  jurisdictions: [
    "Afghanistan",
    "Aland Islands",
    "Albania",
    "Algeria",
    "Andorra",
    "Angola",
    "Anguilla",
    "Antarctica",
    "Antigua and Barbuda",
    "Argentina",
    "Armenia",
    "Aruba",
    "Australia",
    "Austria",
    "Azerbaijan",
    "Bahamas",
    "Bahrain",
    "Bangladesh",
    "Barbados",
    "Belarus",
    "Belgium",
    "Belize",
    "Benin",
    "Bermuda",
    "Bhutan",
    "Bolivia, Plurinational State of",
    "Bonaire, Sint Eustatius and Saba",
    "Bosnia and Herzegovina",
    "Botswana",
    "Bouvet Island",
    "Brazil",
    "British Indian Ocean Territory",
    "Brunei Darussalam",
    "Bulgaria",
    "Burkina Faso",
    "Burundi",
    "Cambodia",
    "Cameroon",
    "Canada",
    "Cape Verde",
    "Cayman Islands",
    "Central African Republic",
    "Chad",
    "Chile",
    "China",
    "Christmas Island",
    "Cocos (Keeling) Islands",
    "Colombia",
    "Comoros",
    "Congo",
    "Congo, the Democratic Republic of the",
    "Cook Islands",
    "Costa Rica",
    "Cote d’Ivoire",
    "Croatia",
    "Cuba",
    "Curaçao",
    "Cyprus",
    "Czech Republic",
    "Denmark",
    "Djibouti",
    "Dominica",
    "Dominican Republic",
    "Ecuador",
    "Egypt",
    "El Salvador",
    "Equatorial Guinea",
    "Eritrea",
    "Estonia",
    "Ethiopia",
    "Falkland Islands (Malvinas)",
    "Faroe Islands",
    "Fiji",
    "Finland",
    "France",
    "French Guiana",
    "French Polynesia",
    "French Southern Territories",
    "Gabon",
    "Gambia",
    "Georgia",
    "Germany",
    "Ghana",
    "Gibraltar",
    "Greece",
    "Greenland",
    "Grenada",
    "Guadeloupe",
    "Guatemala",
    "Guernsey",
    "Guinea",
    "Guinea-Bissau",
    "Guyana",
    "Haiti",
    "Heard Island and McDonald Islands",
    "Holy See (Vatican City State)",
    "Honduras",
    "Hong Kong SAR",
    "Hungary",
    "Iceland",
    "India",
    "Indonesia",
    "Iran, Islamic Republic of",
    "Iraq",
    "Ireland",
    "Isle of Man",
    "Israel",
    "Italy",
    "Jamaica",
    "Japan",
    "Jersey",
    "Jordan",
    "Kazakhstan",
    "Kenya",
    "Kiribati",
    "Korea, Democratic People’s Republic of",
    "Korea, Republic of",
    "Kuwait",
    "Kyrgyzstan",
    "Lao People’s Democratic Republic",
    "Latvia",
    "Lebanon",
    "Lesotho",
    "Liberia",
    "Libya",
    "Liechtenstein",
    "Lithuania",
    "Luxembourg",
    "Macao",
    "Macedonia, the former Yugoslav Republic of",
    "Madagascar",
    "Malawi",
    "Malaysia",
    "Maldives",
    "Mali",
    "Malta",
    "Martinique",
    "Mauritania",
    "Mauritius",
    "Mayotte",
    "Mexico",
    "Moldova, Republic of",
    "Monaco",
    "Mongolia",
    "Montenegro",
    "Montserrat",
    "Morocco",
    "Mozambique",
    "Myanmar",
    "Namibia",
    "Nauru",
    "Nepal",
    "Netherlands",
    "New Caledonia",
    "New Zealand",
    "Nicaragua",
    "Niger",
    "Nigeria",
    "Niue",
    "Norfolk Island",
    "Norway",
    "Oman",
    "Pakistan",
    "Palestine",
    "Panama",
    "Papua New Guinea",
    "Paraguay",
    "Peru",
    "Philippines",
    "Pitcairn",
    "Poland",
    "Portugal",
    "Qatar",
    "Reunion",
    "Romania",
    "Russian Federation",
    "Rwanda",
    "Saint Barthélemy",
    "Saint Helena, Ascension and Tristan da Cunha",
    "Saint Kitts and Nevis",
    "Saint Lucia",
    "Saint Martin (French part)",
    "Saint Pierre and Miquelon",
    "Saint Vincent and the Grenadines",
    "Samoa",
    "San Marino",
    "Sao Tome and Principe",
    "Saudi Arabia",
    "Senegal",
    "Serbia",
    "Seychelles",
    "Sierra Leone",
    "Singapore",
    "Sint Maarten (Dutch part)",
    "Slovakia",
    "Slovenia",
    "Solomon Islands",
    "Somalia",
    "South Africa",
    "South Georgia and the South Sandwich Islands",
    "South Sudan",
    "Spain",
    "Sri Lanka",
    "Sudan",
    "Suriname",
    "Svalbard and Jan Mayen",
    "Swaziland",
    "Sweden",
    "Switzerland",
    "Syrian Arab Republic",
    "Taiwan",
    "Tajikistan",
    "Tanzania, United Republic of",
    "Thailand",
    "Timor-Leste",
    "Togo",
    "Tokelau",
    "Tonga",
    "Trinidad and Tobago",
    "Tunisia",
    "Turkey",
    "Turkmenistan",
    "Turks and Caicos Islands",
    "Tuvalu",
    "Uganda",
    "Ukraine",
    "United Arab Emirates",
    "United Kingdom",
    "United States",
    "Uruguay",
    "Uzbekistan",
    "Vanuatu",
    "Venezuela, Bolivarian Republic of",
    "Vietnam",
    "Virgin Islands, British",
    "Wallis and Futuna",
    "Western Sahara",
    "Yemen",
    "Zambia",
    "Zimbabwe",
  ],
};
